import { EmailContentType, Locales } from "@simplyk/common";

import { RouterOutputs } from "@/common/types/trpc";

export type FormEmailContents = NonNullable<RouterOutputs["getAutomatedEmailContents"]>;
export type EditorEmailContentType = keyof FormEmailContents;
export type EditorEmailText = NonNullable<NonNullable<FormEmailContents[EditorEmailContentType]>[Locales]>;

const NO_OWN_TEXT: EditorEmailText = { subject: null, body: null, attachmentUrl: null };

export const getEditorEmailText = (
  contents: FormEmailContents,
  type: EditorEmailContentType,
  locale: Locales
): EditorEmailText => contents[type]?.[locale] ?? NO_OWN_TEXT;

export const getTicketingThankYouContentType = (isAuction: boolean): EditorEmailContentType =>
  isAuction ? EmailContentType.AUCTION_WINNERS : EmailContentType.THANK_YOU;
